import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class InstalmentDeduction {
  list(
    page,
    limit,
    search,
    startDate,
    endDate,
    sortBy,
    sortType,
    isBookmark,
    minInitialAmount,
    isDeduction,
    installmentType
  ) {
    const params = {
      page: page,
      limit: limit,
      start_date: startDate,
      end_date: endDate,
    };

    if (sortBy) {
      params.sort_by = sortBy;
    }

    if (sortType) {
      params.sort_type = sortType;
    }

    if (isBookmark) {
      params.is_bookmark = isBookmark;
    }

    if (minInitialAmount) {
      params.min_initial_amount = minInitialAmount;
    }

    if (isDeduction) {
      params.is_deduction = isDeduction;
    }

    if (installmentType) {
      params.installment_type = installmentType;
    }

    if (search) {
      params.search = search;
    }

    const endPoint = `/worker/salary/deduction/cicilan?` + new URLSearchParams(params).toString();
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }

  post(payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/deduction/cicilan/posting`;
    return axios.post(url, payload, headersTokenConfig);
  }

  shippingCost(id, payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/deduction/cicilan/${id}/shipping-cost`;
    return axios.put(url, payload, headersTokenConfig);
  }

  checklist(id, itemID, deductionMark) {
    const body = {
      item_id: itemID,
      deduction_mark: deductionMark,
    };

    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/deduction/cicilan/${id}/mark`;
    return axios.put(url, body, headersTokenConfig);
  }
}

export default new InstalmentDeduction();
